import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const wrapMQ = css(mq({
  padding: [
    "32px 0", // 0+
    "32px 0", // 440+
    "64px 0 0", // 768+
    "64px 0 0", // 1024+
    "64px 0 0", // 1200+
    "72px 0 0", // 1400+
  ],
}))

export const Wrap = styled.div`
  ${wrapMQ}
`

const contentMQ = css(mq({
  maxWidth: [
    "calc(100vw - 32px)", // 0+
    "calc(100vw - 32px)", // 440+
    "calc(100vw - 64px)", // 768+
    "calc(100vw - 80px)", // 1024+
  ],
}))

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 1240px;
  margin: 0 auto;
  ${contentMQ}
`

const titleMQ = css(mq({
  font: [
    "var(--accent-670)", // 0+
    "var(--accent-670)", // 440+
    "var(--accent-870)", // 768+
  ],
  marginBottom: [
    32, // 0+
    32, // 440+
    44, // 768+
  ],
}))

export const Title = styled.h2`
  color: var(--color-grayscale-900);
  ${titleMQ}
`

const sectionsWrapMQ = css(mq({
  display: [
    "flex", // 0+
    "flex", // 440+
    "flex", // 768+
    "flex", // 1024+
    "grid", // 1200+
    "flex", // 1400+
  ],
  gridTemplateColumns: [
    "unset", // 0+
    "unset", // 440+
    "unset", // 768+
    "unset", // 1024+
    "1fr 1fr", // 1200+
    "unset", // 1400+
  ],
  flexDirection: [
    "column", // 0+
    "column", // 440+
    "column", // 768+
    "column", // 1024+
    "row", // 1200+
    "row", // 1400+
  ],
  justifyContent: [
    "normal", // 0+
    "normal", // 440+
    "normal", // 768+
    "normal", // 1024+
    "space-between", // 1200+
    "space-between", // 1400+
  ],
  gap: [
    32, // 0+
    32, // 440+
    46, // 768+
    46, // 1024+
    64, // 1200+
    64, // 1400+
  ],

  "& > div:nth-of-type(1)": {
    maxWidth: [
      "unset", // 0+
      "unset", // 440+
      "unset", // 768+
      "unset", // 1024+
      "unset", // 1200+
      520, // 1400+
    ],
  },

  "& > div:nth-of-type(2)": {
    maxWidth: [
      "unset", // 0+
      "unset", // 440+
      "unset", // 768+
      "unset", // 1024+
      "unset", // 1200+
      560, // 1400+
    ],
  },
}))

export const SectionsWrap = styled.div`
  ${sectionsWrapMQ}
`

const sectionMQ = css(mq({
  gap: [
    20, // 0+
    20, // 440+
    24, // 768+
    "24px 40px", // 1024+
    "24px 40px", // 1200+
    32, // 1400+
  ],
}))

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  ${sectionMQ}
`

const headingMQ = css(mq({
  "& > img": {
    width: [
      24, // 0+
      24, // 440+
      32, // 768+
      32, // 1024+
      40, // 1200+
    ],
    height: [
      24, // 0+
      24, // 440+
      32, // 768+
      32, // 1024+
      40, // 1200+
    ],
  }
}))

export const Heading = styled.h3`
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--color-grayscale-900);
  font: var(--text-670);
  ${headingMQ}
`

const imageTextsWrapMQ = css(mq({
  flexDirection: [
    "column", // 0+
    "column", // 440+
    "column", // 768+
    "row", // 1024+
    "column", // 1200+
  ],
}))

export const ImageTextsWrap = styled.div`
  display: flex;
  align-items: start;
  gap: 24px 40px;
  ${imageTextsWrapMQ}
`

const textsMQ = css(mq({
  gridTemplateColumns: [
    "1fr", // 0+
    "repeat(auto-fit, minmax(320px, 1fr))", // 440+
    "repeat(auto-fit, minmax(320px, 1fr))", // 768+
    "1fr", // 1024+
  ],
  gap: [
    20, // 0+
    24, // 440+
    32, // 768+
    24, // 1024+
    24, // 1200+
    24, // 1400+
  ],
}))

export const Texts = styled.div`
  display: grid;
  color: var(--color-grayscale-900);
  font: var(--text-540);
  ${textsMQ}
`

export const Image1 = styled.img`
  flex-shrink: 0;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  background: var(--color-grayscale-37);
  border: 1px solid var(--color-grayscale-50);
`

export const Image2 = styled.img`
  flex-shrink: 0;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  background: var(--color-grayscale-37);
  border: 1px solid var(--color-grayscale-50);
`

const section1FooterMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "grid", // 1200+
    "grid", // 1400+
  ],
}))

export const Section1Footer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 56px;

  ${section1FooterMQ}
`

const section2FooterMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "flex", // 1024+
    "flex", // 1200+
    "flex", // 1400+
  ],
  flexDirection: [
    "row", // 0+
    "row", // 440+
    "row", // 768+
    "column", // 1024+
    "row", // 1200+
  ],
}))

export const Section2Footer = styled.div`
  gap: 16px 56px;

  ${section2FooterMQ}
`

const footerItemMQ = css(mq({
  flexDirection: [
    "column", // 0+
    "column", // 440+
    "column", // 768+
    "row", // 1024+
    "column", // 1200+
  ],
  alignItems: [
    "unset", // 0+
    "unset", // 440+
    "unset", // 768+
    "center", // 1024+
    "unset", // 1200+
  ],
}))

export const FooterItem = styled.div`
  display: flex;
  gap: 16px 12px;
  color: var(--color-grayscale-500);
  ${footerItemMQ}
`

export const FooterTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > strong {
    font: var(--text-540);
  }

  & > p {
    font: var(--text-340);
  }
`
